import React, { useEffect,useState,useContext } from "react";
import responderSolicitudRepresentacionService from '../../../services/responderSolicitudRepresentacionService'


import { withStyles, makeStyles,useTheme } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper ,Collapse,IconButton} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';

import Spinner from '../../Spinner/Spinner'
import DetalleTracking from '../TrackingSolicitud/DetalleTracking';
import { useAlert } from 'react-alert'
import { AppContext } from '../../../App'
import { useAuth } from "react-oidc-context"
import { useConfirm } from 'material-ui-confirm';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';

import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import solicitudRepresentacionTracking from '../../../services/solicitudRepresentacionTracking'
import CsvFromDataCtrl from '../../Csv/CsvFromDataCtrl'




const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),    
  },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);
  
  const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const useStyles = makeStyles((theme) => ({
    table: {
      //minWidth: 700,
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    button: {
      margin: theme.spacing(1),      
    },
    buttonRed: {
      margin: theme.spacing(1),
      backgroundColor: '#f44336',
      "&:hover, &:focus": {
        backgroundColor: '#f54336',
        transition: '0.7s',
      },
      "&:active": {
        backgroundColor: '#f74336',
      }
    },
    buttonGreen: {
      margin: theme.spacing(1),
      backgroundColor: '#4CAF50',
      "&:hover, &:focus": {
        backgroundColor: '#4CBF50',
        transition: '0.7s',
      },
      "&:active": {
        backgroundColor: '#4CCF50',
      }
    },    
    confirmDialogTitle: {
      fontSize: "17px",
    },        
    paginationFooter: {
      fontSize: "12px",
    },
  }));

  const TextOnlyTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 14
    },
  }))(Tooltip);


function  SolicitudesRepresentacionRespondidas({tipoRepresentacionRespondida}){

    const classes = useStyles();

    const [isLoading, setIsLoading] = useState(false)        
     
    const {state, dispatch} = useContext(AppContext)
    const idcorl=state.idCorrelacion
    const auth = useAuth();
    const token = auth.user?.access_token;


    //ALERT + DIÁLOGO
    const alertInfo = useAlert()
    const confirm = useConfirm();
    

    const opcionesDialogo = {
      title : 'Confirme su acción',
      titleProps: {
        className : classes.confirmDialogTitle,
      },               
      confirmationText: 'Sí',
      confirmationButtonProps: {
        variant : "contained",
        //color : "success",
        className : classes.buttonGreen,
        startIcon : <CheckIcon />},
      cancellationText: 'No',
      cancellationButtonProps: { 
        autoFocus: true, 
        variant : "contained",
        //color : "error",
        className : classes.buttonRed,
        startIcon : <CancelIcon /> },      
    };
   
    // *********

    function textoCabeceraRepresentacion(){
        if (tipoRepresentacionRespondida=='Vigente') 
          return 'RESPONDIDAS VIGENTES';
        else if (tipoRepresentacionRespondida=='Baja')
          return 'DE BAJA';
        else
          return 'TipoRepresentacionRespondida no codificada. REVISAR ERROR.';
    }

    function arraySolicitudes(){
      if (tipoRepresentacionRespondida=='Vigente') 
        return state.arraySolicitudesRepresentacionRespondidas;
      else if (tipoRepresentacionRespondida=='Baja')
        return state.arraySolicitudesRepresentacionBajas;
      else
        return null;
    }
    
    function arraySolicitudesUI(){
      if (tipoRepresentacionRespondida=='Vigente') 
        return state.arraySolicitudesRepresentacionRespondidasUI;
      else if (tipoRepresentacionRespondida=='Baja')
        return state.arraySolicitudesRepresentacionBajasUI;
      else
        return null;
    }


    const formateaFechaGuiones = (fechaText) => {
              
      var fechaFormateada = '';
      
      var fecha = new Date(fechaText);
      if (fecha != null && !isNaN(fecha.getTime()) && fecha instanceof Date){
        var fechaSinGMT = new Date(fecha.toUTCString().split(' ').slice(0, 4).join (' '))
        const dia = fechaSinGMT.getDate().toString().padStart(2,'0');
        const mes = (fechaSinGMT.getMonth() + 1).toString().padStart(2,'0');
        const anyo = fechaSinGMT.getFullYear().toString();

        fechaFormateada = dia + '/' + mes + '/' + anyo;
      }
      
      return fechaFormateada;
    }

    function textoOtroIdentificacion(tipoSolicitudRepresentacion, rolDelUsuarioEnLaSolicitud, nifRepresentante, nombreRepresentante, nifRepresentado, nombreRepresentado)
    {
      if (textoUsuarioEnCalidadDe(tipoSolicitudRepresentacion, rolDelUsuarioEnLaSolicitud) == "Mi Representado")
            //return nifRepresentado + (SolicitudDeRepresentado(tipoSolicitudRepresentacion)? ' - ' + nombreRepresentado : '');
            return nifRepresentado +" "  +nombreRepresentado;
      else if (textoUsuarioEnCalidadDe(tipoSolicitudRepresentacion, rolDelUsuarioEnLaSolicitud) == "Mi Representante")
          return nifRepresentante +" "  +nombreRepresentante;
      else
          return '---';
    }

    function textoAlcanceRepresentacion(tipoRepresentacion){
      return 'Completa';
    }

    function textoUsuarioEnCalidadDe(tipoSolicitudRepresentacion, rolDelUsuarioEnLaSolicitud)
    {     
      if (SolicitudDeRepresentante(tipoSolicitudRepresentacion)) {
        if (EnCalidadDeEmisorSolicitud(rolDelUsuarioEnLaSolicitud)){
          return 'Mi Representado';
        }
        else if (EnCalidadDeReceptorSolicitud(rolDelUsuarioEnLaSolicitud)){
          return 'Mi Representante';
        }
      }          
      else if (SolicitudDeRepresentado(tipoSolicitudRepresentacion)) {
        if (EnCalidadDeEmisorSolicitud(rolDelUsuarioEnLaSolicitud)){
          return 'Mi Representante';
        }
        else if (EnCalidadDeReceptorSolicitud(rolDelUsuarioEnLaSolicitud)){
          return 'Mi Representado';
        }
      } 
      else
          return '---';      
    }

    function toolTipEstado(idEstado){
      switch (idEstado) {
        //case 0:          
        //  return 'No conocemos este estado ';
        case 1:          
          return '';
        case 2:          
          return 'La otra parte interviniente acepta la solicitud y se crea la relación de representación, que entra en vigor en la fecha de aceptación';
        case 3:          
          return 'La otra parte interviniente rechaza la solicitud sin crearse la relación de representación';
        case 4:          
          return 'Una vez creada la relación de representación, ésta expira porque se ha alcanzado la fecha de vigencia establecida';
        case 5:          
          return 'La solicitud se ha cancelado por el solicitante antes de ser aceptada por la otra parte interviniente';
        case 6:          
          return 'Una vez creada la relación de representación, una de las dos partes intervinientes la revoca dejándola a partir de ese momento sin efecto';
        case 7:          
          return 'La solicitud caduca si transcurre un mes sin que ninguna de las dos personas interesadas hayan intervenido sobre ella, o bien si la fecha de fin de vigencia vence antes que ese mes y no se ha intervenido sobre ella';
        case 8:          
          return 'Representación dada de baja debido a que el NIF ya no consta como activo en las bases de datos de Hacienda Foral de Navarra.';
        case 9:
          return 'Baja de representación por inicio de proceso concursal.';
        case 10:          
          return 'Baja de representación por fin de proceso concursal.';
        case 13:          
          return 'Baja de representación por absorción.';
        default:
          return '-';
      }
    }

    function textoEstado(idEstado){
      switch (idEstado) {
        //case 0:          
        //  return 'Sin definir';
        case 1:          
          return 'Solicitada';
        case 2:          
          return 'Aceptada';
        case 3:          
          return 'Rechazada';
        case 4:          
          return 'Expirada';
        case 5:          
          return 'Cancelada';
        case 6:          
          return 'Revocada';
        case 7:          
          return 'Caducada';
        case 8:
            return 'Anulada por baja en BD personas';
        case 9:
            return 'Anulada por inicio concurso';
        case 10:
              return 'Anulada por final de concurso';
        case 13:
              return 'Anulada por absorción';
        default:
          return '-';
      }
    }

    function EnCalidadDeEmisorSolicitud(rolDelUsuarioEnLaSolicitud){
      if ( rolDelUsuarioEnLaSolicitud == 1 ) 
        return true;      
      
      return false;
    }

    function EnCalidadDeReceptorSolicitud(rolDelUsuarioEnLaSolicitud){
      if ( rolDelUsuarioEnLaSolicitud == 2 ) 
        return true;      
      
      return false;
    }
    

    function SolicitudDeRepresentante(tipoSolicitudRepresentacion){
      if (tipoSolicitudRepresentacion == 1) 
        return true;
      return false;
    }

    function SolicitudDeRepresentado(tipoSolicitudRepresentacion){
      if (tipoSolicitudRepresentacion == 2) 
        return true;
      return false;
    }


    const updateListaSolicitudesPendientes = (newValue) => {
      dispatch({ type: 'UPDATE_SOLICITUDES_PENDIENTES_STATUS', data: newValue,});
    };

    const updateListaSolicitudesRespondidas = (newValue) => {
      dispatch({ type: 'UPDATE_SOLICITUDES_RESPONDIDAS_STATUS', data: newValue,});
    };
    
    const updateListaSolicitudesRespondidasUI = (newValue) => {
      dispatch({ type: 'UPDATE_SOLICITUDES_RESPONDIDAS_UI_STATUS', data: newValue,});
    };

    const updateListaSolicitudesBajas = (newValue) => {
      dispatch({ type: 'UPDATE_SOLICITUDES_BAJAS_STATUS', data: newValue,});
    };
    
    const updateListaSolicitudesBajasUI = (newValue) => {
      dispatch({ type: 'UPDATE_SOLICITUDES_BAJAS_UI_STATUS', data: newValue,});
    };

    /////    
    /* function AddEstadoArrow(idSolicitud,valor){
      state.arrayArrows.push({idSolicitud:idSolicitud , valor:false});

    }
    function ActualizarEstadoArrow(idSolicitud){
      var itemIndex = state.arrayArrows.findIndex(x => x.idSolicitud == idSolicitud);
      
      
      var item = state.arrayArrows[itemIndex]
      item.valor = !item.valor;
      
      state.arrayArrows[itemIndex] = item
    }
    
    */
   
    function mapeaResponderSolicitud(id, tipoAccion){      
      let datosResponderSolicitud = {        
          "idSolicitud" : parseInt(id),//'-1', //          
          "respuesta": parseInt(tipoAccion)          
      }

      return datosResponderSolicitud;
    }

    function handleAccionRevocar(id, tipoAccion) {                  
      var accion = "revocar"; 
      confirm({...opcionesDialogo, description : <div style={{fontSize: '17px'}}>¿Está seguro de querer {accion} su solicitud?</div>}) 
      .then(() => { 
        setIsLoading(true)        
        responderSolicitudRepresentacionService({datosResponderSolicitud: mapeaResponderSolicitud(id, tipoAccion), idcorl, token})
        .then(datos => {          
            setIsLoading(false)
            
            if (datos.ok){
              const newListRespondidas = state.arraySolicitudesRepresentacionRespondidas.filter((item) => item.idSolicitud !== id);   
              //newListRespondidas.push(datos.respuesta);            
              updateListaSolicitudesRespondidas(newListRespondidas);

              const newListRespondidasUI = state.arraySolicitudesRepresentacionRespondidasUI.filter((item) => item.idSolicitud !== id);   
              //newListRespondidasUI.push(datos.respuesta);            
              updateListaSolicitudesRespondidasUI(newListRespondidasUI);

              const newListBajas = state.arraySolicitudesRepresentacionBajas.filter((item) => item.idSolicitud !== id);  
              newListBajas.push(datos.respuesta);            
              updateListaSolicitudesBajas(newListBajas);

              const newListBajasUI = state.arraySolicitudesRepresentacionBajasUI.filter((item) => item.idSolicitud !== id);  
              newListBajasUI.push(datos.respuesta);            
              updateListaSolicitudesBajasUI(newListBajasUI);
                                        
              alertInfo.success("Solicitud revocada con éxito.");                                     
            }
            else{
              alertInfo.error(<div>Solicitud NO enviada. <br/><br/> {datos.mjeError} </div>, { timeout: 0 });  
            }
    
        }).catch((error) => {
            alert("Ha ocurrido un error. Por favor póngase en contacto con soporte (soportec@navarra.es) facilitando el identificador de correlación.");
            setIsLoading(false)
        })   
      })
      .catch(() => { alertInfo.error("Acción cancelada", { timeout: 0 }); });
       
    }    

     //////////////////////////////// PAGINACION
     function TablePaginationActions(props) {
      const classes = useStyles1();
      const theme = useTheme();
      const { count, page, rowsPerPage, onPageChange } = props;
    
      const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
      };
    
      const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
      };
    
      const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
      };
    
      const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
      };
    
      return (
        <div className={classes.root}>
          <IconButton
            onClick={handleFirstPageButtonClick}
            disabled={page === 0}
            aria-label="first page"
          >
            {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
          </IconButton>
          <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
          </IconButton>
          <IconButton
            onClick={handleNextButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="next page"
          >
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </IconButton>
          <IconButton
            onClick={handleLastPageButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="last page"
          >
            {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
          </IconButton>
        </div>
      );
    }

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, arraySolicitudesUI().length - page * rowsPerPage);

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
    /////////////////////////////////////////////////////////
/*
    function encuentraTraking(idSolicitud){
      
        return ((state.arrayTrackingSolicitud.length >0) && (state.idSolicitudTracking==idSolicitud) );
    }
*/
    function Row(props) {
      
      const handleTracking=(idSolicitud) => {
          if (open){
              setOpen(false);
          }else{
            setTracking();
            getSolicitudRepresentacionTracking(idSolicitud);
            setOpen(true);
          }
      }
      function getSolicitudRepresentacionTracking(id){         
        solicitudRepresentacionTracking({idSolicitud: id, idcorl, token})
        .then(datos => {          
            setIsLoading(false)
            
            if (datos.ok){            
              
              setTracking(datos.respuesta);

            }
            else{
                alertInfo.error(<div>Error al consultar la Solicitud Cancelada. <br/><br/> {datos.mjeError} </div>, { timeout: 0 });  
            }
    
        }).catch((error) => {
            alert("Ha ocurrido un error. Por favor póngase en contacto con soporte (soportec@navarra.es) facilitando el identificador de correlación.");
                    
        }) 
      }
      
     
      
      const { row } = props;
      const [open, setOpen] = React.useState(false);
      const [tracking, setTracking] = React.useState();
      
    
      return (
        <React.Fragment>
          <StyledTableRow  key={row.idSolicitud}>
            <StyledTableCell align="center">{textoAlcanceRepresentacion(row.tipoRepresentacion)}</StyledTableCell>
            <StyledTableCell align="center">{textoOtroIdentificacion(row.tipoSolicitudRepresentacion, row.rolDelUsuarioEnLaSolicitud, row.nifRepresentanteSolicitud, row.razonSocialRepresentanteSolicitud, row.nifRepresentadoSolicitud, row.razonSocialRepresentadoSolicitud)}</StyledTableCell>
            <StyledTableCell align="center">{textoUsuarioEnCalidadDe(row.tipoSolicitudRepresentacion, row.rolDelUsuarioEnLaSolicitud)}</StyledTableCell>
            <StyledTableCell align="center">        
              <TextOnlyTooltip title={toolTipEstado(row.estadoActual)} >
                <div>{textoEstado(row.estadoActual)}</div>
              </TextOnlyTooltip>
            </StyledTableCell>
            <StyledTableCell align="center">{formateaFechaGuiones(row.fechaUltMod)}</StyledTableCell>
            <StyledTableCell align="center">{formateaFechaGuiones(row.vigencia)}</StyledTableCell>                                        
            {row.estadoActual == 2 &&
              <>
              <StyledTableCell align="center"><button type="button" className="btn btn-success" onClick={() => handleAccionRevocar(row.idSolicitud, 2)}>Revocar</button></StyledTableCell>
              </>
            }
            {row.estadoActual != 2 &&
              <>
              <StyledTableCell align="center">
                
              </StyledTableCell>
              </>
            }     
            <StyledTableCell> 
              <IconButton aria-label="expand row" size="small" onClick={() => handleTracking(row.idSolicitud)}>
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </StyledTableCell> 
                                                                         
          </StyledTableRow>
          <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box margin={1}>
                 
                  <DetalleTracking tracking={tracking}></DetalleTracking>
                 
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        </React.Fragment>
      );
    }
    
     const headers = [
        { label: 'Alcance representación', key: 'alcance' },
        { label: 'Identificación', key: 'identificacion' },
        { label: 'En calidad de', key: 'calidadDe' },
        { label: 'Estado', key: 'estado' },
        { label: 'Fecha estado', key: 'fechaEstado' },
        { label: 'Fecha vigencia', key: 'fechaVigencia' }
    ];
    
   function DameDatosCsv(datos){
      let data = [];
     
      datos.map((row) => (
        data.push ({
          alcance: textoAlcanceRepresentacion(row.tipoRepresentacion),
          identificacion:textoOtroIdentificacion(row.tipoSolicitudRepresentacion, row.rolDelUsuarioEnLaSolicitud, row.nifRepresentanteSolicitud, row.razonSocialRepresentanteSolicitud, row.nifRepresentadoSolicitud, row.razonSocialRepresentadoSolicitud),
          calidadDe:textoUsuarioEnCalidadDe(row.tipoSolicitudRepresentacion, row.rolDelUsuarioEnLaSolicitud),
          estado:textoEstado(row.estadoActual),          
          fechaEstado:formateaFechaGuiones(row.fechaUltMod),
          fechaVigencia:formateaFechaGuiones(row.vigencia)
        })
      ));
      
      return data;
   }


  useEffect(() => {           
    if (state.resetPagina0){
      setPage(0);
      dispatch({ type: 'UPDATE_RESET_PAGE', data: false,});           
    }
  }); 
  useEffect(() => { if( arraySolicitudesUI().length === rowsPerPage && page > 0 ) { setPage(0); } }, [arraySolicitudesUI().length, rowsPerPage, page]);


    return (
        <>
            {isLoading && <div><strong>Actualizando...</strong><Spinner></Spinner></div>}

            {!isLoading && (!arraySolicitudes() || arraySolicitudes().length <= 0) && 
                <div>
                  <strong>NO TIENE SOLICITUDES {textoCabeceraRepresentacion()}</strong>
                  <br/>                  
                </div>
            }

            {!isLoading && arraySolicitudes() && arraySolicitudes().length > 0 &&             
                <div>                            
                    <div><strong>SOLICITUDES {textoCabeceraRepresentacion()}:</strong></div>
                    <div align="rigth">
                    {(arraySolicitudes()) &&
                      <strong><CsvFromDataCtrl headers={headers} data={DameDatosCsv(arraySolicitudes())}></CsvFromDataCtrl></strong>
                    }
                    </div>
                    <TableContainer component={Paper}>
                        <Table  className={classes.table} size="small" aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                  <StyledTableCell align="center">Alcance representación</StyledTableCell>
                                  <StyledTableCell align="center">Identificación</StyledTableCell>                            
                                  <StyledTableCell align="center">En calidad de</StyledTableCell>
                                  <StyledTableCell align="center">Estado</StyledTableCell>
                                  <StyledTableCell align="center">Fecha estado</StyledTableCell>                                    
                                  <StyledTableCell align="center">Fecha vigencia</StyledTableCell>                                    
                                  <StyledTableCell align="center">Acciones </StyledTableCell>
                                  <StyledTableCell align="center"> </StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {(rowsPerPage > 0
                                ? arraySolicitudesUI().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : arraySolicitudesUI()
                              ).map((row) => (
                                <Row key={row.idSolicitud} row={row} />
                              ))}

                               
                            </TableBody>
                            <TableFooter>
                              <TableRow>
                                <TablePagination
                                  classes = {{
                                    toolbar: classes.paginationFooter,
                                    caption: classes.paginationFooter
                                  }}
                                  rowsPerPageOptions={[5, 10, 25, { label: 'Todos', value: -1 }]}
                                  colSpan={3}
                                  count={arraySolicitudesUI().length}
                                  rowsPerPage={rowsPerPage}
                                  page={( page > 0 && arraySolicitudesUI().length === rowsPerPage ) ? 0 : page}
                                  labelRowsPerPage = "Filas por página"
                                  labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                                  SelectProps={{
                                    inputProps: { 'aria-label': 'Filas por página'},
                                    native: true,
                                  }}
                                  onPageChange={handleChangePage}
                                  onRowsPerPageChange={handleChangeRowsPerPage}
                                  ActionsComponent={TablePaginationActions}
                                />
                              </TableRow>
                            </TableFooter>
                            
                        </Table>
                       
                    </TableContainer>
                    
                </div>                    
            }
          
            
            

        </>
        )
}
export default SolicitudesRepresentacionRespondidas
